import { EntityType  } from "../../settingDefinition/models/enums/EntityType";

export interface SettingProps {
  id: string;
  entity_type: EntityType;
  entity_id: string;
  key: string;
  value: string | number | null;
}
  
  export class Setting implements SettingProps {
    public readonly id: string;
    public readonly entity_type: EntityType;
    public readonly entity_id: string;
    public readonly key: string;
    public readonly value: string | number | null;

    constructor(data: SettingProps) {
      this.id = data.id;
      this.entity_type = data.entity_type;
      this.entity_id = data.entity_id;
      this.key = data.key;
      this.value = data.value;
    }
  }
  